import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  Form,
  Menu,
  Icon,
  Button,
  Loader,
  Header,
  Modal,
  Radio,
  Checkbox,
  Segment,
  Dropdown,
  Input,
  Item,
} from "semantic-ui-react";
import {
  Container,
  Title,
  Field,
  Label,
  InputFile,
  InputText,
  InputLabel,
} from "../../../../../pages/Admin/Empresas/criarEmpresas/styled";

const Planos = (props) => {
  const [planos, setPlanos] = useState({
    curso: "",
    bolsas: "",
    acesso: "",
    nome: "",
  });
  const [view, setView] = useState(props.valor);
  const [deletar, setDeletar] = useState(props.del);
  const [criar, setCriar] = useState(props.criar);
  const [modificar, setModificar] = useState(props.edit);

  const [editar, setEditar] = useState({
    id: 0,
    curso: "",
    newCurso: "",
    bolsas: "",
    acesso: "",
    nome: "",
  });
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [cursoValue, setCursoValue] = useState(props.cursos);

  useEffect(() => {}, []);

  const addTabela = useCallback(
    (id, bolsas, acesso, text) => {
      const value = [
        ...view,
        { curso: id, bolsas: bolsas, acesso: acesso, cur: { curso: text } },
      ];

      setView([
        ...view,
        { curso: id, bolsas: bolsas, acesso: acesso, cur: { curso: text } },
      ]);
      setCriar((criar) => [
        ...criar,
        {
          empresa: props.id,
          curso: id,
          bolsas: bolsas,
          acesso: acesso,
          cur: { curso: text },
        },
      ]);
      handleValueCriar([
        ...criar,
        {
          empresa: props.id,
          curso: id,
          bolsas: bolsas,
          acesso: acesso,
          cur: { curso: text },
        },
      ]);
      handleValue(value);
    },
    [view, criar]
  );

  const editTabela = useCallback(
    (id, id_curso, cursos, bolsas, acesso, nome) => {

      const newTabela = view.map((curso) => {
        if (curso.curso == id_curso) {
          const newEditar = [
            ...modificar,
            {
              id,
              empresa: props.id,
              curso: cursos,
              bolsas: bolsas,
              acesso: acesso,
              cur: { curso: nome },
            },
          ];
          setModificar(newEditar);
          handleValueEdit(newEditar);
          return {
            ...curso,
            empresa: props.id,
            curso: cursos,
            bolsas: bolsas,
            acesso: acesso,
            cur: { curso: nome },
          };
        } else {
          return {
            ...curso,
            empresa: props.id,
            curso: curso.curso,
            bolsas: curso.bolsas,
            acesso: curso.acesso,
          };
        }
      });
      handleValue(newTabela);
      setView(newTabela);
    },
    [view, edit]
  );

  const deleteTabela = useCallback(
    (id) => {
      const newCurso = view.filter((curso) => curso.curso !== id);
      const newDelete = view.filter((curso) => curso.curso === id);
      if (newDelete[0].id == null) {
        const newCriar = criar.filter((curso) => curso.curso !== id);
        setCriar(newCriar);
        handleValueCriar(newCriar);
      } else {
        const newDel = [...deletar, ...newDelete];
        setDeletar(newDel);
        handleValueDel(newDel);
      }
      setView(newCurso);
      handleValue(newCurso);
    },
    [view, criar]
  );

  const handleValue = (valor) => {
    props.handlePlanos(valor);
  };
  const handleValueCriar = (valor) => {
    props.handlePlanosCriar(valor);
  };
  const handleValueEdit = (valor) => {
    props.handlePlanosEdit(valor);
  };
  const handleValueDel = (valor) => {
    props.handlePlanosDel(valor);
  };

  return (
    <>
      <Modal
        closeIcon
        open={open}
        trigger={
          <Button>
            <Icon name="add" />
            Adicionar plano
          </Button>
        }
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Header content="Plano Empresa" />
        <Modal.Content>
          <div>
            <Label>Curso:</Label>
            <Dropdown
              placeholder="Escolha um curso"
              fluid
              search
              selection
              options={cursoValue}
              onChange={(e, data) => {
                setPlanos({
                  ...planos,
                  curso: data.value,
                  nome: e.target.textContent,
                });
              }}
            />
          </div>
          <div>
            <Label>Número de Licenças:</Label>
            <Input
              type="text"
              onChange={(e) => setPlanos({ ...planos, bolsas: e.target.value })}
            />
          </div>
          <div>
            <Label>Tempo de Acesso (Dias)</Label>
            <Input
              type="text"
              onChange={(e) => setPlanos({ ...planos, acesso: e.target.value })}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="green"
            onClick={() => {
              setOpen(false);
              addTabela(
                planos.curso,
                planos.bolsas,
                planos.acesso,
                planos.nome
              );
            }}
          >
            <Icon name="checkmark" /> confirmar
          </Button>
          <Button
            color="red"
            onClick={() => {
              setOpen(false);
            }}
          >
            <Icon name="remove" /> cancelar
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        closeIcon
        open={edit}
        onClose={() => setEdit(false)}
        onOpen={() => setEdit(true)}
      >
        <Header content="Editar plano" />
        <Modal.Content>
          <div>
            <Label>Curso:</Label>
            <Dropdown
              placeholder="Escolha um curso"
              fluid
              search
              selection
              value={editar.newCurso}
              options={cursoValue}
              onChange={(e, data) => {
                setEditar({
                  ...editar,
                  newCurso: data.value,
                  nome: e.target.textContent,
                });
              }}
            />
          </div>
          <div>
            <Label>Número de Licenças:</Label>
            <Input
              type="number"
              value={editar.bolsas}
              onChange={(e) => setEditar({ ...editar, bolsas: e.target.value })}
            />
          </div>
          <div>
            <Label>Tempo de Acesso (Dias)</Label>
            <Input
              type="number"
              value={editar.acesso}
              onChange={(e) => setEditar({ ...editar, acesso: e.target.value })}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="green"
            onClick={() => {
              setEdit(false);
              editTabela(
                editar.id,
                editar.curso,
                editar.newCurso,
                editar.bolsas,
                editar.acesso,
                editar.nome
              );
            }}
          >
            <Icon name="checkmark" /> confirmar
          </Button>
          <Button
            color="red"
            onClick={() => {
              setEdit(false);
            }}
          >
            <Icon name="remove" /> cancelar
          </Button>
        </Modal.Actions>
      </Modal>

      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Curso</Table.HeaderCell>
            <Table.HeaderCell>Licenças</Table.HeaderCell>
            <Table.HeaderCell>Tempo de Acesso</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {view.map((curso) => (
            <Table.Row>
              <Table.Cell>
                {console.log("curso", curso)}[{curso.curso}] -{" "}
                {curso.cur == null ? "este curso não existe" : curso.cur.curso}
              </Table.Cell>
              <Table.Cell>{curso.bolsas}</Table.Cell>
              <Table.Cell>{curso.acesso}</Table.Cell>
              <Table.Cell>
                <>
                  <Button
                    icon="edit"
                    info="editar"
                    onClick={() => {
                      setEdit(true);
                      setEditar({
                        ...editar,
                        id: curso.id,
                        curso: curso.curso,
                        newCurso: curso.curso,
                        bolsas: curso.bolsas,
                        acesso: curso.acesso,
                        nome: curso.cur.curso,
                      });
                    }}
                  ></Button>
                  <Button
                    icon="trash icon"
                    info="delete"
                    onClick={() => {
                      deleteTabela(curso.curso);
                    }}
                  ></Button>
                </>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

export default Planos;
